import { ConcurrentModel } from 'src/app/shared/models/concurrent-report.model';
import { Injectable } from '@angular/core';
import { API_URL } from 'src/app/config/api.constant';
import { map } from 'rxjs/operators';
import * as Config from 'src/app/config/app.constant';
import { HttpClient } from '@angular/common/http';
import { UploadModel } from 'src/app/shared/models/upload.model';
import openPDF from 'src/app/modules/concurrent-report/service/concurrent-pdf.service'
import { UtilsService } from 'src/app/shared/services/utils/utils.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class InsuredReportService {

  constructor(private http: HttpClient,
    public util: UtilsService,
    public translate: TranslateService

  ) { }

  doBlob() {
    return new Promise((resolve, reject) => {
      try {
        var newlogo = new Image()
        newlogo.src = 'assets/images/LOGOTL.png'
        console.log(newlogo.src)
        fetch(newlogo.src)
          .then(res => res.blob())
          .then(blob => {
            this.util.changeFile(blob).then(res => {
              resolve(res);
            })
          })
      } catch (err) {
        reject(err);
      }
    });
  }

  public print(concurrentData: any) {
    return new Promise((resolve, reject) => {
      try {
        this.doBlob().then((logoTL: String) => {
          let data ={
            logoTL : logoTL,
            concurrentData: concurrentData,
            lang : this.translate.currentLang
          }
          openPDF(data).then((res:string) => {
            resolve(res);
          })
        })
      } catch (err) {
        reject(err);
      }
    });
  }

  public searchConcurrent(params: any) {
    return this.http.post(`${API_URL.searchConcurrent}`, params, Config.HTTP_OPTIONS_SMARTCLAIM).pipe(map((res) => res));
  }

  public insertConcurrent(params: ConcurrentModel) {
    return this.http.post(`${API_URL.insertConcurrent}`, params, Config.HTTP_OPTIONS_SMARTCLAIM).pipe(map((res) => res));
  }

  public uploadFile(params: UploadModel) {
    return this.http.post(`${API_URL.uploadFile}`, params, Config.HTTP_OPTIONS_SMARTCLAIM).pipe(map((res) => res));
  }

}
